import React from 'react';

export interface Image {
  alt: string;
  imageType?: string;
  transforms: Record<string, {
    url: string;
    width: string;
    height: string;
  }>;
}

interface PictureProps {
  image: Image;
  defaultTransform: string;
  loading: 'lazy' | 'eager';
  classes?: string | undefined;
  alt?: string | undefined;
}

export default function Picture({
  image,
  defaultTransform,
  loading,
  classes,
  alt,
}: PictureProps) {
  const media = {
    all: '',
    xxs: '(max-width: 412px)',
    xs: '(max-width: 639px)',
    sm: '(max-width: 767px)',
    md: '(max-width: 1023px)',
    lg: '(max-width: 1199px)',
    xl: '(max-width: 1439px)',
    '2xl-min': '(min-width: 1440px)',
    '2xl': '(max-width: 1519px)',
    '3xl': '(max-width: 1919px)',
    '4k': '(min-width: 3840px)',
    '4xl': '(min-width: 1920px)',
  };

  return (
    image && (
      <picture>
        {Object.entries(media).map(([key, value]) => (
          (image.transforms[key]) && (
            <source
              media={value}
              srcSet={image.transforms[key]?.url}
              key={key}
              width={image.transforms[key]?.width}
              height={image.transforms[key]?.height}
            />
          )
        ))}
        <img
          src={image.transforms[defaultTransform]?.url}
          alt={alt || image.alt || ''}
          loading={loading}
          width={image.transforms[defaultTransform]?.width}
          height={image.transforms[defaultTransform]?.height}
          className={classes}
        />
      </picture>
    )
  );
}
